import {createAction, handleActions} from "redux-actions";
import uuid from "react-uuid";

const SET_HOUSE_DATA = 'rent/SET_HOUSE_DATA';
const ADD_HOUSE_DATA = 'rent/ADD_HOUSE_DATA';
const EDIT_HOUSE_DATA = 'rent/EDIT_HOUSE_DATA';
const EDIT_HOUSE_ADDRESS = 'rent/EDIT_HOUSE_ADDRESS';
const REMOVE_HOUSE_DATA = 'rent/REMOVE_HOUSE_DATA';

const SET_COMMERCIAL_DATA = 'rent/SET_COMMERCIAL_DATA';
const ADD_COMMERCIAL_DATA = 'rent/ADD_COMMERCIAL_DATA';
const EDIT_COMMERCIAL_DATA = 'rent/EDIT_COMMERCIAL_DATA';
const EDIT_COMMERCIAL_ADDRESS = 'rent/EDIT_COMMERCIAL_ADDRESS';
const REMOVE_COMMERCIAL_DATA = 'rent/REMOVE_COMMERCIAL_DATA';

const ADD_HOUSE_CHECKLIST = 'rent/ADD_HOUSE_CHECKLIST';
const REMOVE_HOUSE_CHECKLIST = 'rent/REMOVE_HOUSE_CHECKLIST';
const CLEAR_HOUSE_CHECKLIST = 'rent/CLEAR_HOUSE_CHECKLIST';

const ADD_COMMERCIAL_CHECKLIST = 'rent/ADD_COMMERCIAL_CHECKLIST';
const REMOVE_COMMERCIAL_CHECKLIST = 'rent/REMOVE_COMMERCIAL_CHECKLIST';
const CLEAR_COMMERCIAL_CHECKLIST = 'rent/CLEAR_COMMERCIAL_CHECKLIST';

export const setHouseData = createAction(SET_HOUSE_DATA, data => data);
export const addHouseData = createAction(ADD_HOUSE_DATA, rent => rent);
export const editHouseData = createAction(EDIT_HOUSE_DATA, ({id, column, value}) => ({id, column, value}));
export const editHouseAddress = createAction(EDIT_HOUSE_ADDRESS, ({id, zpcd, addr}) => ({id, zpcd, addr}));
export const removeHouseData = createAction(REMOVE_HOUSE_DATA, id => id);

export const setCommercialData = createAction(SET_COMMERCIAL_DATA, data => data);
export const addCommercialData = createAction(ADD_COMMERCIAL_DATA, rent => rent);
export const editCommercialData = createAction(EDIT_COMMERCIAL_DATA, ({id, column, value}) => ({id, column, value}));
export const editCommercialAddress = createAction(EDIT_COMMERCIAL_ADDRESS, ({id, zpcd, addr}) => ({id, zpcd, addr}));
export const removeCommercialData = createAction(REMOVE_COMMERCIAL_DATA, id => id);

export const addHouseChecklist = createAction(ADD_HOUSE_CHECKLIST, item => item);
export const removeHouseChecklist = createAction(REMOVE_HOUSE_CHECKLIST, item => item);
export const clearHouseChecklist = createAction(CLEAR_HOUSE_CHECKLIST, item => item);

export const addCommercialChecklist = createAction(ADD_COMMERCIAL_CHECKLIST, item => item);
export const removeCommercialChecklist = createAction(REMOVE_COMMERCIAL_CHECKLIST, item => item);
export const clearCommercialChecklist = createAction(CLEAR_COMMERCIAL_CHECKLIST, item => item);

const initialState = {
    house: {},
    commercial: {},
    houseChecklist: [],
    commercialChecklist: []
};

const rent = handleActions(
    {
        [SET_HOUSE_DATA]: (state, action) => {
            action.payload.map(item => item["id"] = "house-" + uuid());
            const house = action.payload.reduce((nextObjs, obj) => ({
                ...nextObjs,
                [obj["id"]]: obj,
            }), {});

            return { ...state, house };
        },
        [ADD_HOUSE_DATA]: (state, action) => {
            const newState = {
                ...state,
                house: {
                    ...state.house,
                    ["house-" + uuid()]: {
                        kognrRentCd: "HC051001",
                        taxAccntYn: "",
                        taxAccntNm: "",
                        taxAccntTelno: "",
                        rentAgentNm: "",
                        rentAgentZpcd: "",
                        rentAgentAddr: "",
                        rentAgentAddrDetls: "",
                        rentIncomeAmt: "",
                        rentDepositAmt: "",
                        jointYn: "",
                        shareRate: "",
                        stdMktAmt: "",
                        ddcArea: "",
                        bizRegYn: "",
                        rentBizYn: "",
                        crtby: "",
                        crtip: ""
                    }
                }
            };
            return newState;
        },
        [EDIT_HOUSE_DATA]: (state, action) => {
            const tmpObj = state.house[action.payload.id];
            const newState = {
                ...tmpObj,
                [action.payload.column]: action.payload.value
            };
            return {
                ...state,
                house: {
                    ...state.house,
                    [action.payload.id]: newState
                }
            };
        },
        [EDIT_HOUSE_ADDRESS]: (state, action) => {
            const tmpObj = state.house[action.payload.id];
            const newState = {
                ...tmpObj,
                rentAgentZpcd: action.payload.zpcd,
                rentAgentAddr: action.payload.addr,
                rentAgentAddrDetls: ""
            };
            return {
                ...state,
                house: {
                    ...state.house,
                    [action.payload.id]: newState
                }
            };
        },
        [REMOVE_HOUSE_DATA]: (state, action) => {
            const tmpData = { ...state.house };
            delete tmpData[action.payload];
            const newState = {
                ...state,
                house: tmpData
            };
            return newState;
        },
        [SET_COMMERCIAL_DATA]: (state, action) => {
            action.payload.map(item => item["id"] = "commercial-" + uuid());
            const commercial = action.payload.reduce((nextObjs, obj) => ({
                ...nextObjs,
                [obj["id"]]: obj,
            }), {});

            return { ...state, commercial };
        },
        [ADD_COMMERCIAL_DATA]: (state, action) => {
            const newState = {
                ...state,
                commercial: {
                    ...state.commercial,
                    ["commercial-" + uuid()]: {
                        kognrRentCd: "HC051002",
                        taxAccntYn: "",
                        taxAccntNm: "",
                        taxAccntTelno: "",
                        rentAgentNm: "",
                        rentAgentZpcd: "",
                        rentAgentAddr: "",
                        rentAgentAddrDetls: "",
                        rentIncomeAmt: "",
                        rentDepositAmt: "",
                        jointYn: "",
                        shareRate: "",
                        crtby: "",
                        crtip: ""
                    }
                }
            };
            return newState;
        },
        [EDIT_COMMERCIAL_DATA]: (state, action) => {
            const tmpObj = state.commercial[action.payload.id];
            const newState = {
                ...tmpObj,
                [action.payload.column]: action.payload.value
            };
            return {
                ...state,
                commercial: {
                    ...state.commercial,
                    [action.payload.id]: newState
                }
            };
        },
        [EDIT_COMMERCIAL_ADDRESS]: (state, action) => {
            const tmpObj = state.commercial[action.payload.id];
            const newState = {
                ...tmpObj,
                rentAgentZpcd: action.payload.zpcd,
                rentAgentAddr: action.payload.addr,
                rentAgentAddrDetls: ""
            };
            return {
                ...state,
                commercial: {
                    ...state.commercial,
                    [action.payload.id]: newState
                }
            };
        },
        [REMOVE_COMMERCIAL_DATA]: (state, action) => {
            const tmpData = { ...state.commercial };
            delete tmpData[action.payload];
            const newState = {
                ...state,
                commercial: tmpData
            };
            return newState;
        },
        [ADD_HOUSE_CHECKLIST]: (state, action) => {
            const newState = {
                ...state,
                houseChecklist: [...state.houseChecklist, action.payload]
            };
            return newState;
        },
        [REMOVE_HOUSE_CHECKLIST]: (state, action) => {
            const newState = {
                ...state,
                houseChecklist: state.houseChecklist.filter(item => item !== action.payload)
            };
            return newState;
        },
        [CLEAR_HOUSE_CHECKLIST]: (state, action) => {
            const newState = {
                ...state,
                houseChecklist: []
            };
            return newState;
        },
        [ADD_COMMERCIAL_CHECKLIST]: (state, action) => {
            const newState = {
                ...state,
                commercialChecklist: [...state.commercialChecklist, action.payload]
            };
            return newState;
        },
        [REMOVE_COMMERCIAL_CHECKLIST]: (state, action) => {
            const newState = {
                ...state,
                commercialChecklist: state.commercialChecklist.filter(item => item !== action.payload)
            };
            return newState;
        },
        [CLEAR_COMMERCIAL_CHECKLIST]: (state, action) => {
            const newState = {
                ...state,
                commercialChecklist: []
            };
            return newState;
        },
    },
    initialState
);

export default rent;
